import styled from "styled-components";

const Heading = styled.h1`
  font-size: 25px !important;
  font-weight: 800 !important;
  line-height: 1.3;
  margin-bottom: 4px;
`;
export default Heading;
